import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ach-icon',
  templateUrl: './ach-icon.component.html',
  styles: []
})
export class AchIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
